import React from 'react'
import CustomTable from '../../../shared/CustomTable'
import { useTranslation } from 'react-i18next'

function Table(props) {
  const { t } = useTranslation()
  const { data, loading, columns, ...rest } = props

  return (
    <div>
      <CustomTable
        data={data}
        isLoading={loading}
        columns={columns(t)}
        {...rest}
      />
    </div>
  )
}

export default Table
